import script from "./CartEmpty.vue?vue&type=script&setup=true&lang=js"
export * from "./CartEmpty.vue?vue&type=script&setup=true&lang=js"

import "./CartEmpty.vue?vue&type=style&index=0&id=dece8f88&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dece8f88"]])

export default __exports__